import { useMutation } from 'react-query';
import { axiosInstance } from '@shared/lib/axios';
import { MUTATIONS_INFO } from '@shared/lib/const';
import type { TAxiosError } from '@shared';
import type { TNewLoginPayload } from '@entities/user';
export const useChangeUserEmail = (uuid: string) => useMutation<unknown, TAxiosError, TNewLoginPayload>((payload: TNewLoginPayload) => axiosInstance.post(MUTATIONS_INFO.adminUserChangeEmail.replace('[uuid]', uuid), payload));